export const TIME_QUARTERS = (() => {
  const quarters = [];
  for (let i = 0; i < 24; i += 1) {
    for (let j = 0; j < 4; j += 1) {
      const hour = i < 10 ? `0${i}` : `${i}`;
      const minutes = 15 * j === 0 ? "00" : 15 * j;
      quarters.push(`${hour}:${minutes}:00`);
    }
  }
  return quarters;
})();

export const TIME_HOURS = (() => {
  const hours = [];
  for (let i = 0; i < 24; i += 1) {
    const hour = i < 10 ? `0${i}` : `${i}`;
    hours.push(`${hour}:00:00`);
  }
  return hours;
})();

export const TIME_HORIZONS = [
  { intervalDays: 1, label: "24h" },
  { intervalDays: 30, label: "30d" },
  { intervalDays: 90, label: "90d" },
  { intervalDays: 365, label: "1y" },
];

export const GRANULARITY_LEVELS = [
  { value: "MIN15", label: "15M" },
  { value: "HOUR", label: "1H" },
  { value: "DAY", label: "1D" },
  { value: "MONTH", label: "1M" },
  { value: "YEAR", label: "1Y" },
];

export const MONTHS = [
  { value: "1", label: "Janeiro" },
  { value: "2", label: "Fevereiro" },
  { value: "3", label: "Março" },
  { value: "4", label: "Abril" },
  { value: "5", label: "Maio" },
  { value: "6", label: "Junho" },
  { value: "7", label: "Julho" },
  { value: "8", label: "Agosto" },
  { value: "9", label: "Setembro" },
  { value: "10", label: "Outubro" },
  { value: "11", label: "Novembro" },
  { value: "12", label: "Dezembro" },
];

export default { TIME_QUARTERS, TIME_HORIZONS, GRANULARITY_LEVELS, MONTHS };
